import React from "react";

const CandImage = ({
  handleOverlay,
  passImage,
  image,
  firstName,
  styles = ""
}) => (
  <div
    className={`${styles ||
      "tw-w-20 tw-h-20 tw-m-1 tw-mx-2 tw-mr-3 tw-cursor-pointer"}`}
  >
    <img
      onClick={() => {
        handleOverlay();
        passImage(image);
      }}
      className="tw-h-full tw-w-full tw-rounded-full tw-border-2 tw-border-gray-400 hover:tw-border-yellow-300 tw-shadow-sm"
      src={`data:image/png;base64, ${image}`}
      alt={`${firstName} Profile`}
    />
  </div>
);

export default CandImage;
